// extracted by mini-css-extract-plugin
export default {"upsalePopup":"YIkJT","heading":"GvP7b","discount":"Z1A1Q","description":"g4MkC","tariffCard":"pewyJ","resetButton":"b0KOi","tariffContainer":"dAERM"};